import { Header, Icon, Popup, VerticalMenu } from '@scuf/common';
import i18n from 'i18n';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NavigateFunction } from 'react-router-dom';
import packageJson from '../../../package.json';

const tam = 845;
type Props = {
    title: string;
    navigate: NavigateFunction;
    messageState: any;
    showState: any;
    isLoading?: boolean;
};
export const BaseHeader: React.FC<Props> = ({ title, navigate, messageState, showState, isLoading }: Props) => {
    const [collapsed, setCollapsed] = useState<boolean>(true);
    const width = window.innerWidth;
    const { t } = useTranslation(['common', 'pages']);

    function handleChangeLang(_lang: string) {
        i18n.changeLanguage(_lang);
    }
    return (
        <>
            {width > tam ? (
                <Header
                    title={t(title)}
                    logoUrl={process.env.PUBLIC_URL + '/brady.png'}
                    menu={width < tam ? true : false}
                    onLogoClick={() => navigate('/')}
                >
                    <Header.Item onClick={() => navigate('/info/contract')}>{t('pages:contracts')}</Header.Item>
                    <Header.Item onClick={() => navigate('/info/certified')}>{t('pages:certified')}</Header.Item>
                    <Header.Item onClick={() => navigate('/info/solutions')}>{t('pages:solutions')}</Header.Item>

                    {!isLoading ? (
                        <Header.Item style={{ fontWeight: 'bold' }} href={process.env.REACT_APP_SSO_LOGIN}>{t('actions.SignIn')}</Header.Item>
                    ) : (
                        <Header.Item style={{ fontWeight: 'bold', color: '#d3d3d3' }}>{t('actions.SignIn')}</Header.Item>
                    )}

                    <Header.Item style={{ fontWeight: 'bold' }} href={process.env.REACT_APP_SSO_REGISTER}>{t('actions.SignUp')}</Header.Item>
                    <Popup
                        className="popup-theme-wrap"
                        element={<Header.IconItem icon={<Icon name="globe" root="common" />} description={t('language.Language')} />}
                        on="click"
                    >
                        <VerticalMenu>
                            <VerticalMenu.Header>{t('language.Language')}</VerticalMenu.Header>
                            <VerticalMenu.Item onClick={() => handleChangeLang('pt')}>{t('language.Portuguese')}</VerticalMenu.Item>
                            <VerticalMenu.Item onClick={() => handleChangeLang('en')}>{t('language.English')}</VerticalMenu.Item>
                            <VerticalMenu.Item onClick={() => handleChangeLang('es')}>{t('language.Español')}</VerticalMenu.Item>
                            <VerticalMenu.Item>{packageJson.version}</VerticalMenu.Item>
                        </VerticalMenu>
                    </Popup>
                </Header>
            ) : (
                <Header title={t(title)} menu={width < tam ? true : false} onMenuToggle={() => setCollapsed(!collapsed)} />
            )}
        </>
    );
};

export default BaseHeader;
